import { ATextInput, ATextInputBaseProps } from '../inputs';

export interface ABankAccountInputProps extends ATextInputBaseProps<string> {}

export default function ABankAccountInput(props: ABankAccountInputProps) {
    return <ATextInput {...props} maxLength={42} minLength={16} regExp={/^[A-Z]{2}[A-Z\d ]+$/} />;
}
